import React from 'react';
import { bool, func, object } from 'prop-types';
import _ from 'lodash';
import { RECENTLY_VIEWED } from '../../utils/carousels';
import SafePureComponent from '../shared/SafePureComponent';
import localStorage from './localStorage';
import { RECENTLY_VIEWED_SOURCE } from './RecentlyViewedGigs/config';
import RecentlyViewedGigs from './RecentlyViewedGigs';

const RecentlyViewedGigsWrapper = ({
    isLoggedIn,
    collections = {},
    updateCollections = _.noop,
    isTouch = false,
    shouldFetchCarousel = true
}, {
    pathfinderWrapper,
    general
}) => {
    const { gigId } = general;

    const getRecentlyUrl = () => {
        const query = { exclude: gigId };

        if (!isLoggedIn) {
            query.gig_ids = localStorage.getGigIds(gigId);
        }

        return pathfinderWrapper.pathfinder(
            'gig_page_fetch_recommendations_by_type',
            { type: 'recently_viewed' },
            { query }
        );
    };

    if (!isLoggedIn && !localStorage.getGigIds(gigId).length) {
        return null;
    }

    return (
        <RecentlyViewedGigs isLoggedIn={isLoggedIn}
            url={getRecentlyUrl()}
            type={RECENTLY_VIEWED}
            carouselPosition={4}
            collections={collections}
            isTouch={isTouch}
            updateCollections={updateCollections}
            source={RECENTLY_VIEWED_SOURCE}
            shouldFetchCarousel={shouldFetchCarousel}/>
    );
};

RecentlyViewedGigsWrapper.propTypes = {
    isLoggedIn: bool,
    collections: object,
    updateCollections: func,
    isTouch: bool,
    shouldFetchCarousel: bool
};

RecentlyViewedGigsWrapper.contextTypes = {
    general: object,
    pathfinderWrapper: object
};

export { RecentlyViewedGigsWrapper };
export default SafePureComponent(RecentlyViewedGigsWrapper);
